/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Direct indexing strategy parameter (mirrors com.ndvr.portfolio.model.strategy.DirectIndex in Java)
 * @export
 */
export const DirectIndex = {
    NDVR_1500_PASSIVE: 'NDVR_1500_PASSIVE',
    NDVR_1500_MQVS: 'NDVR_1500_MQVS',
    NDVR_1500_MQV: 'NDVR_1500_MQV'
} as const;
export type DirectIndex = typeof DirectIndex[keyof typeof DirectIndex];


export function instanceOfDirectIndex(value: any): boolean {
    for (const key in DirectIndex) {
        if (Object.prototype.hasOwnProperty.call(DirectIndex, key)) {
            if (DirectIndex[key as keyof typeof DirectIndex] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DirectIndexFromJSON(json: any): DirectIndex {
    return DirectIndexFromJSONTyped(json, false);
}

export function DirectIndexFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectIndex {
    return json as DirectIndex;
}

export function DirectIndexToJSON(value?: DirectIndex | null): any {
    return value as any;
}

export function DirectIndexToJSONTyped(value: any, ignoreDiscriminator: boolean): DirectIndex {
    return value as DirectIndex;
}

